import type { TimeRange } from "@/lib/time-range";
import type { QmFrictionParams } from "@/hooks/useQmFriction";
import type { QmFunnelParams } from "@/hooks/useQmFunnel";

export const qk = {
  ready: () => ["ready"] as const,
  skyagentNav: () => ["skyagent-nav"] as const,
  me: {
    current: () => ["me"] as const,
  },
  users: {
    list: () => ["users"] as const,
    byId: (id: string) => ["users", id] as const,
  },
  metrics: {
    traffic: (r: TimeRange) => ["metrics", "traffic", r] as const,
    homepagePaths: (r: TimeRange) => ["metrics", "homepage-paths", r] as const,
    journey: (r: TimeRange) => ["metrics", "journey", r] as const,
    funnel: (r: TimeRange) => ["metrics", "funnel", r] as const,
    reservationUsers: (r: TimeRange) => ["metrics", "reservation-users", r] as const,
    conversion: (r: TimeRange) => ["metrics", "conversion", r] as const,
    auth: (r: TimeRange) => ["metrics", "auth", r] as const,
    postLoginFbo: (r: TimeRange) => ["metrics", "post-login-fbo", r] as const,
    performance: (r: TimeRange) => ["metrics", "performance", r] as const,
  },
  dashboards: {
    list: () => ["dashboards"] as const,
    byId: (id: string) => ["dashboards", id] as const,
  },
  savedSearches: {
    list: () => ["saved-searches"] as const,
  },
  alerts: {
    list: () => ["alerts"] as const,
  },
  qm: {
    friction: (params: QmFrictionParams) => ["qm", "friction", params] as const,
    funnel: (params: QmFunnelParams) => ["qm", "funnel", params] as const,
  },
} as const;
